export const name = "ASINH";
export const summary = `Computes the inverse hyperbolic sine of \`X\`.`;
export const reference = `
## ASINH

Computes the inverse hyperbolic sine of \`X\`.

\`\`\`
ASINH(X)
\`\`\`

### Description

Computes the inverse hyperbolic sine of X. Doesn't fail.

| X | ASINH(X) |
| --- | --- |
| \`+inf\` | \`+inf\` |
| \`-inf\` | \`-inf\` |
| \`NaN\` | \`NaN\` |


source: https://cloud.google.com/bigquery/docs/reference/standard-sql/mathematical_functions
`;
